import React from 'react';

import type { PermissionTag as PermissionTagName } from '@vlabs/api/artemy/model';
import { LockOffIcon } from '@vlabs/icons';
import { Tag } from '@vlabs/uikit/components/tag';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import classNames from 'classnames';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './PermissionTag.module.sass';

export interface PermissionTagProps extends WithClassNameProp, WithDataTestid {
  permissionTag: PermissionTagName;
}

const displayName = 'PermissionTag';
const testid = buildTestid(displayName);

function PermissionTag({
  className = undefined,
  permissionTag,
  'data-testid': dataTestId = undefined,
}: PermissionTagProps): React.JSX.Element {
  return (
    <Tag
      className={classNames(st.Root, className)}
      icon={<LockOffIcon />}
      kind="primary"
      shape="square"
      size="large"
      value={permissionTag}
      {...testid(dataTestId)}
    />
  );
}

PermissionTag.displayName = displayName;

export { PermissionTag };
